import { Box, BoxProps } from '@air/zephyr';
import { motion, useSpring, useTransform, useViewportScroll } from 'framer-motion';
import Image from 'next/image';

import { useRefScrollProgress } from '~/hooks/useRefScrollProgress';

export type AdobeSplashOverviewSectionTemplateFeaturedImageProps = Pick<BoxProps, 'tx'>;

export const AdobeSplashOverviewSectionTemplateFeaturedImage = ({
  tx,
}: AdobeSplashOverviewSectionTemplateFeaturedImageProps) => {
  const { ref, start, end } = useRefScrollProgress({ offset: -0.1 });
  const { scrollYProgress } = useViewportScroll();

  const layer1XPos = useTransform(scrollYProgress, [start, end], [400, 0]);
  const layer1XPosAnimation = useSpring(layer1XPos, { stiffness: 200, damping: 20 });
  const layer2XPos = useTransform(scrollYProgress, [start, end], [-400, 0]);
  const layer2XPosAnimation = useSpring(layer2XPos, { stiffness: 200, damping: 20 });

  return (
    <Box tx={{ width: '100%', maxWidth: 1160, ...tx }} ref={ref}>
      <Box tx={{ position: 'relative', pb: '51.9%' }}>
        <Box
          as={motion.div}
          tx={{ position: 'absolute', top: 0, right: 0, width: '69.8%' }}
          style={{ x: layer1XPosAnimation }}
        >
          <Image height={603} src="/assets/marketing/adobe-splash-overview-template-layer-1.png" width={811} />
        </Box>
        <Box
          as={motion.div}
          tx={{ position: 'absolute', top: '9.1%', left: 0, width: '48.5%' }}
          style={{ x: layer2XPosAnimation }}
        >
          <Image height={522.5} src="/assets/marketing/adobe-splash-overview-template-layer-2.png" width={564.5} />
        </Box>
      </Box>
    </Box>
  );
};
